import { Button, Theme, styled } from '@quillbot/design-system';

export default styled(Button)`
  &&.quillArticleBtn {
    padding: 5px 25px 6px;
    font-size: 1.25em;
    font-weight: bold;
    border-radius: 25px;
    text-transform: capitalize;
    position:relative;
    width: 140px;
    min-height:40px;
  }
  &&.quillArticleBtn span{
    display:flex;
    flex-direction:column;
  }
  &&.quillArticleBtnExt {
    border-radius: 4px;
    height: 38px;
    min-width: 50px;
    padding: 0px 8px;
    // width: 90px;
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &&.quillArticleBtnExt:disabled{
    background: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    &&:hover:{
      background: ${({ theme }: { theme: Theme }) => theme.palette.primary.light};
    }
    }
    &&.quillArticleBtnExt:disabled span{
      color:#fff;
      }
  &&.quillArticleBtn:disabled{
    background: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    &&:hover:{
      background: ${({ theme }: { theme: Theme }) => theme.palette.primary.light};
    }
    }
  &&.quillArticleBtn:disabled span{
    color:#fff;
    }
  @media screen and (max-width: 767px) {
    &&.quillArticleBtn {
      border-radius: 40px;
      height: 40px;
      min-width: 143px;
      font-size: 16px;
      // padding: 0px;
      // width: 110px;
    }
  }
  /* @media screen and (max-width: 600px) {
    &&.quillArticleBtn {
      // width: 110px;
      height: 40px;
      font-size: 16px;
      border-radius: 40px;
      padding: 0 12px
    }
  } */
}
`;
